import React from 'react'
import { motion } from 'framer-motion'
import { skillsBar } from '../../utils/constants'
import './skills.css'

const Skills = () => {
  return (
    <>
        <section id='skills' className='skills-main-wrapper'>
            <h2>What i do</h2>
            <div className='skills-description'>As a fullstack software developer, my role is diverse and dynamic, involving both frontend and backend development to create functional, robust and user-friendly applications. </div>
            <motion.div whileInView={{y: [100, 50, 0], opacity: [0, 0, 1]}} transition={{ duration: 1.5 }} className='skills-bars-container'>
                {skillsBar.map((result, index) => (
                    <div key={index} className='skills-bars'>
                        <div className='skills-bar'>
                            <div className='skills-bar-image'>
                                <img src={result.image} alt='bar-img' />
                            </div>
                            <div className='skills-bar-text'>
                                <h3>{result.title}</h3>
                                <span>{result.description}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </motion.div>
        </section>
    </>
  )
}

export default Skills